import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPurchaseCheckList, deletePurchaseCheck } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { mapGetters } from "vuex";
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'BairunPurchaseCheck',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  data: function data() {
    return {
      listApi: getPurchaseCheckList,
      type: '',
      showSelSeller: false,
      oilCodeDict: [],
      summaries: {},
      searchInfo: {
        stationId: '',
        startDate: '',
        endDate: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');
              _context2.next = 3;
              return getDict('oilCode');

            case 3:
              _this2.oilCodeDict = _context2.sent;

              _this2.init();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.asyncStations && _this3.asyncStations.length === 1) {
                  _this3.searchInfo.stationId = _this3.asyncStations[0].ID;
                }

                _this3.onSubmit();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.showSelSeller = false;
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.dataType = 'tankin';

      if (this.searchInfo.oilCode === '') {
        delete this.searchInfo.oilCode;
      }

      this.getTableData();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var page, pageSize, table;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
                _context4.next = 4;
                return _this4.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this4.searchInfo));

              case 4:
                table = _context4.sent;

                if (table.code === 0 && table.data.list != null) {
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;
                  _this4.tableData = table.data.list;
                  _this4.summaries = table.data.heji;

                  _this4.$forceUpdate();
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getSummaries: function getSummaries() {
      return ['合计', '', '', this.summaries.hejiGiveInTon + '（吨）', this.summaries.hejiGiveInLiters + '（升）'];
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    onAdd: function onAdd() {
      this.$router.push({
        name: 'BairunPurchaseCheckAdd',
        query: {},
        params: {
          meta: {
            title: '新增油品采购登记'
          },
          gobackParam: {
            isGoback: true
          },
          action: 'add'
        }
      });
    },
    onUpdate: function onUpdate(row) {
      this.$router.push({
        name: 'BairunPurchaseCheckUpdate',
        query: {},
        params: {
          meta: {
            title: '变更油品采购登记'
          },
          gobackParam: {
            isGoback: true
          },
          action: 'update',
          row: JSON.parse(JSON.stringify(row))
        }
      });
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deletePurchaseCheck(row).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.getTableData();
          }
        }, function (err) {});
      }).catch(function (err) {});
    }
  }
};